// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import FieldDefinition, {
    ExcludeFromNavigation,
    HideFromSearchEngines,
    HideFromSiteSearch,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import React, { FC } from "react";

export interface RequestQuotePageStyles {
    page?: MobiusPageProps;
}

export const requestQuotePageStyles: RequestQuotePageStyles = {};
const styles = requestQuotePageStyles;

const RequestQuotePage: FC<PageProps> = ({ id }) => (
    <Page {...styles.page}>
        <Zone contentId={id} zoneName="Content" />
    </Page>
);

const pageModule: PageModule = {
    component: RequestQuotePage,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "System",
        fieldDefinitions: [
            { ...HideFromSearchEngines, defaultValue: true, isVisible: x => false },
            { ...HideFromSiteSearch, defaultValue: true, isVisible: x => false },
            { ...ExcludeFromNavigation, defaultValue: true, isVisible: x => false },
        ] as FieldDefinition[],
    },
};

export default pageModule;
